export const NotFound = () => <div>Invalid Route</div>;

export default NotFound;
